import { useEffect, useState } from 'react';
import {
  AdditionalServiceNotCompleteReasonsDropdown,
  NudosTextArea,
  NudosUploadDownloadButton
} from '../../../../NudosComponents';
import {
  IadditionalServiceDataForToolLogistics,
  IadditionalServiceNotCompleteReason
} from '../../../../../types/product.configuration.types';
import { InotCompletedData } from '../AdditionalServiceStatusModalContent';
import { validateImageOrPdfCallback } from '../../../../../utils/validateFiles';
import { ADDITIONAL_SERVICE_STATUS_MODAL_VALUES } from '../../../../../types/product.configuration.types';
import { VISUAL_EVIDENCE_FILE_EXTENSIONS } from '../../../../../constants/constants';
import './NotCompletedAdditionalServiceFields.scss';

const NotCompletedAdditionalServiceFields = ({
  type,
  initialData,
  updateDataCallback,
  additionalServiceData,
  uploadProofFile,
  isConfiguration
}: {
  type: ADDITIONAL_SERVICE_STATUS_MODAL_VALUES;
  initialData?: InotCompletedData;
  additionalServiceData: IadditionalServiceDataForToolLogistics;
  updateDataCallback: React.Dispatch<React.SetStateAction<InotCompletedData | undefined>>;
  uploadProofFile: (file?: File) => void;
  isConfiguration?: boolean;
}) => {
  const [notCompleteReason, setNotCompleteReason] = useState<IadditionalServiceNotCompleteReason>();
  const [otherReasonComment, setOtherReasonComment] = useState<string>('');

  const { configurationImageUrls, imageUrl: additionalServiceImageUrl } = additionalServiceData?.status || {};
  const imageUrl =
    configurationImageUrls?.find(ciUrl => VISUAL_EVIDENCE_FILE_EXTENSIONS.includes(ciUrl.split('.').pop() || '')) ||
    additionalServiceImageUrl;
  const isOtherReason = notCompleteReason?.name?.toLowerCase() === 'otras razones' || isConfiguration;
  const currentFileUrl =
    type === ADDITIONAL_SERVICE_STATUS_MODAL_VALUES.SEE_NOT_COMPLETED_REASONS ? imageUrl : undefined;

  useEffect(() => {
    const newReasonId = notCompleteReason?.id || initialData?.logisticAdditionalServiceNotCompletedReasonId;
    if (!newReasonId) return;
    const newData = {
      logisticAdditionalServiceNotCompletedReasonId: newReasonId,
      otherReasonComment: otherReasonComment || initialData?.otherReasonComment
    };
    updateDataCallback(newData);
  }, [notCompleteReason?.name, otherReasonComment]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!otherReasonComment && initialData?.otherReasonComment)
      setOtherReasonComment(initialData.otherReasonComment || '');
  }, [initialData?.otherReasonComment]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={`notCompletedAdditionalServiceFields ${isOtherReason ? 'otherReason' : ''}`}>
      <AdditionalServiceNotCompleteReasonsDropdown
        currentValue={notCompleteReason}
        initialReasonId={initialData?.logisticAdditionalServiceNotCompletedReasonId}
        clickSelectOptionCallback={setNotCompleteReason}
        isConfiguration={isConfiguration}
      />
      {isOtherReason && (
        <NudosTextArea
          label="Otras razones"
          placeholder="Describe las razones"
          currentValue={otherReasonComment || ''}
          maxLength={1000}
          setCurrentValue={setOtherReasonComment}
          componentSize="medium"
          textHeight={64}
          noResize
          hidenCounter
        />
      )}
      <NudosUploadDownloadButton
        customClassName="uploadProofButton notCompleteProof"
        customWidth="280px"
        uploadedFileHandler={uploadProofFile}
        downloadButtonText="Consultar evidencia"
        buttonEmptyText="PDF o JPG"
        buttonFilledText="PDF o JPG"
        showSkeletonLoader={false}
        keepOwnFileState
        currentFileUrl={currentFileUrl || undefined}
        validateFileCallback={validateImageOrPdfCallback}
      />
    </div>
  );
};

export default NotCompletedAdditionalServiceFields;
